export const widgetWrappersCollection = {}